const TRANSCRIPT_TIMESTAMP = /\s*(\*\*\d{1,2}:\d{2}(?::\d{2})?\*\*)/g

const breakTranscriptTurns = (text: string) => {
  return text.replace(TRANSCRIPT_TIMESTAMP, (_match, timestamp: string, offset: number) =>
    offset === 0 ? timestamp : `\n${timestamp}`,
  )
}

const toHardBreaks = (text: string) => text.replace(/([^\n])\n(?!\n)/g, '$1  \n')

export const toMessageMarkdown = (body?: string | null) => {
  return toHardBreaks(breakTranscriptTurns(String(body ?? '').trim()))
}
